/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1PersonIdAttachmentsMutationRequest,
  PostApiV1PersonIdAttachmentsMutationResponse,
  PostApiV1PersonIdAttachmentsPathParams,
  PostApiV1PersonIdAttachments400,
  PostApiV1PersonIdAttachments401,
  PostApiV1PersonIdAttachments404,
  PostApiV1PersonIdAttachments500,
} from "../../types/personDocumentsController/PostApiV1PersonIdAttachments.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1PersonIdAttachments } from "../../clients/personDocumentsController/postApiV1PersonIdAttachments.ts";

export const postApiV1PersonIdAttachmentsMutationKey = () =>
  [{ url: "/api/v1/person/:id/attachments" }] as const;

export type PostApiV1PersonIdAttachmentsMutationKey = ReturnType<
  typeof postApiV1PersonIdAttachmentsMutationKey
>;

export function postApiV1PersonIdAttachmentsMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PostApiV1PersonIdAttachmentsMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1PersonIdAttachmentsMutationKey();
  return mutationOptions<
    PostApiV1PersonIdAttachmentsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAttachments400
      | PostApiV1PersonIdAttachments401
      | PostApiV1PersonIdAttachments404
      | PostApiV1PersonIdAttachments500
    >,
    {
      id: PostApiV1PersonIdAttachmentsPathParams["id"];
      data?: PostApiV1PersonIdAttachmentsMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return postApiV1PersonIdAttachments(id, data, config);
    },
  });
}

/**
 * @description Upload de anexo de matrícula. Body multipart: classStudentId (opcional, contexto da turma), enrollmentDocumentId (tipo de documento) e file. **(Requer Authorization para autenticação)**
 * @summary Criar anexo de matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments}
 */
export function usePostApiV1PersonIdAttachments<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1PersonIdAttachmentsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1PersonIdAttachments400
        | PostApiV1PersonIdAttachments401
        | PostApiV1PersonIdAttachments404
        | PostApiV1PersonIdAttachments500
      >,
      {
        id: PostApiV1PersonIdAttachmentsPathParams["id"];
        data?: PostApiV1PersonIdAttachmentsMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1PersonIdAttachmentsMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1PersonIdAttachmentsMutationKey();

  const baseOptions = postApiV1PersonIdAttachmentsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1PersonIdAttachmentsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAttachments400
      | PostApiV1PersonIdAttachments401
      | PostApiV1PersonIdAttachments404
      | PostApiV1PersonIdAttachments500
    >,
    {
      id: PostApiV1PersonIdAttachmentsPathParams["id"];
      data?: PostApiV1PersonIdAttachmentsMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1PersonIdAttachmentsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAttachments400
      | PostApiV1PersonIdAttachments401
      | PostApiV1PersonIdAttachments404
      | PostApiV1PersonIdAttachments500
    >,
    {
      id: PostApiV1PersonIdAttachmentsPathParams["id"];
      data?: PostApiV1PersonIdAttachmentsMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1PersonIdAttachmentsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAttachments400
      | PostApiV1PersonIdAttachments401
      | PostApiV1PersonIdAttachments404
      | PostApiV1PersonIdAttachments500
    >,
    {
      id: PostApiV1PersonIdAttachmentsPathParams["id"];
      data?: PostApiV1PersonIdAttachmentsMutationRequest;
    },
    TContext
  >;
}
